// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"857":"016ab9bc","884":"bd8a4858"}[chunkId] + ".chunk.js";
};